import { CheckTokenEndpoint } from './endpoint'
import { HttpMethods } from '../../apiService/baseEndpoint'
import { CheckTokenResponse } from './checkTokenResponse'
import { CheckTokenParams } from './checkTokenParams'

export const checkTokenRequest = async (payload: CheckTokenParams): Promise<CheckTokenResponse> => {
  const endpoint = new CheckTokenEndpoint<undefined, CheckTokenParams>('', HttpMethods.POST, undefined, payload)
  return endpoint.execute()
}
